import React from "react";
import { Box, Typography } from "@mui/material";

import { useAssignment } from "../../globals/AssignmentContext";
import { useUser } from "../../globals/UserContext";
import ClassPickerList from "./ClassPickerList";

const modalStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    minWidth: 500,
    height: 400,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
  };

export default function ClassPicker(props) {
  const assignment = useAssignment();
  const user = useUser()

  const { handleClassPicked } = props

  const handleAdd = (classID) => {
    handleClassPicked(classID, true)
  }

  const handleRemove = (classID) => {
    handleClassPicked(classID, false)
  }

  // Filter the classrooms that will be available to add the assignment to
  // Remove those classes that we find in the assignments assigned_to array
  const classrooms = user?.classes?.filter(x => {
    try {
      // If entries in user.classes are strings they are probably the ids already
      if (typeof x === "string") return !assignment?.assigned_to?.includes(x)
      // Otherwise they are probably populated with class data, so use the id in the class object to compare
      else return !assignment?.assigned_to?.includes(x._id)
    } catch {
      // If there was some kind of error we probably don't want to include the entry as a selectable class
      return false
    }
  })

  return (
    props.open ? (
    <Box sx={modalStyle}>
      <Typography id="modal-modal-title" variant="h5" component="h2" >
        Assigned to the following classes
      </Typography>
      <Typography id="modal-modal-title" variant="subtitle2">
        Click to unassign
      </Typography>
      {assignment?.assigned_to?.map((classroom) => <ClassPickerList variant="h6" handlePick={(classID) => handleRemove(classID)} key={(typeof classroom === "string") ? classroom : classroom._id} classroom={classroom}></ClassPickerList>)}
      

      <br/>
      <br/>
      <Typography id="modal-modal-title" variant="h5" component="h2">
        Remaining Classes
      </Typography>
      <Typography id="modal-modal-title" variant="subtitle2">
        Click to assign
      </Typography>
      {classrooms?.map((assigned) => <ClassPickerList variant="h6" handlePick={(classID) => handleAdd(classID)} key={(typeof assigned === "string") ? assigned : assigned._id} classroom={assigned}></ClassPickerList>)}
      <br/>
    </Box>
    ) : (
      <></>
    )
  )
}